import React from 'react';
import { Container, Row, Col, Input, Label } from 'reactstrap';
import i18n from "../../../i18next";
import MaterialIcon from 'material-icons-react';
import moment from 'moment';
class FilterSelectionScreen extends React.Component {

    state = {
        filters: {},
        selectedFilter: null,
        productName: '',
        promotionName: '',
        matchedProductsFromSearch: [],
        matchedPromotionsFromSearch: [],
        isFromMatchedProductsSearch: false,
        isFromMatchedPromotionsSearch: false
    }

    changeState = e => {
        const value = e.target.value === '' ? null : e.target.value
        this.setState({ filters: { ...this.state.filters, [e.target.name]: value } })
    }

    changeProductName = e => {
        this.setState({ 
            productName: e.target.value,
            isFromMatchedProductsSearch: false 
        })
    }

    changePromotionName = e => {
        this.setState({ 
            promotionName: e.target.value,
            isFromMatchedPromotionsSearch: false 
        })
    }

    changeDateState = e => {
        let targetValue = e.target.value;
        targetValue = e.target.value.split(/\D/);
        targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
        targetValue = moment(targetValue).format("DD-MM-YYYY")

        this.setState({ filters: { ...this.state.filters, [e.target.name]: targetValue } });
    }

    selectFilter = filter => {
        this.setState({ selectedFilter: filter, filters: this.props.filters, products: this.props.products, promotions: this.props.promotions })
    }

    getOrderTypeValue = value => {
        const orderTypes = [...this.state.filters.orderTypeCollection];
        let result = false;
        orderTypes.forEach(element => {
            if (element.id === value) {
                result = true;
            }
        });

        return result;
    }

    changeOrderTypeValue = e => {

        const id = parseInt(e.target.name);
        let orderTypes = [...this.state.filters.orderTypeCollection];

        const foundElement = orderTypes.find(element => element.id === id);
        if (foundElement && e.target.checked === false) {
            const index = orderTypes.findIndex(element => element.id === id);
            orderTypes.splice(index, 1);
        } else if (!foundElement && e.target.checked) {
            orderTypes.push({ id: id, name: this.getOrderTypeName(id) });
        }
        this.setState({ filters: { ...this.state.filters, orderTypeCollection: orderTypes } });
    }

    getOrderTypeName = id => {
        switch (id) {
            case 1: return 'Delivery';
            case 2: return 'Collection';
            case 4: return 'Curbside';
            case 5: return 'In Store';
            default: return null;
        }
    }

    getTenderTypeValue = value => {
        const tenderTypes = [...this.state.filters.paymentTypeCollection];
        let result = false;
        tenderTypes.forEach(element => {
            if (element.id === value) {
                result = true;
            }
        });
        return result;
    }

    changeTenderTypeValue = e => {

        const id = parseInt(e.target.name);
        let tenderTypes = [...this.state.filters.paymentTypeCollection];

        const foundElement = tenderTypes.find(element => element.id === id);
        if (foundElement && e.target.checked === false) {
            const index = tenderTypes.findIndex(element => element.id === id);
            tenderTypes.splice(index, 1);
        } else if (!foundElement && e.target.checked) {
            tenderTypes.push({ id: id, name: this.getTenderTypeName(id) });
        }
        this.setState({ filters: { ...this.state.filters, paymentTypeCollection: tenderTypes } });

    }

    getTenderTypeName = id => {
        switch (id) {
            case 1: return 'Credit card';
            case 2: return 'Cash';
            case 3: return 'Loyalty';
            case 4: return 'Gift card';
            default: return null;
        }
    }

    getSourceTypeValue = value => {
        const sourceTypes = [...this.state.filters.sourceTypeCollection];
        let result = false;
        sourceTypes.forEach(element => {
            if (element.id === value) {
                result = true;
            }
        });
        return result;
    }

    changeSourceTypeValue = e => {

        const id = parseInt(e.target.name);
        let sourceTypes = [...this.state.filters.sourceTypeCollection];

        const foundElement = sourceTypes.find(element => element.id === id);
        if (foundElement && e.target.checked === false) {
            const index = sourceTypes.findIndex(element => element.id === id);
            sourceTypes.splice(index, 1);
        } else if (!foundElement && e.target.checked) {
            sourceTypes.push({ id: id, name: this.getSourceTypeName(id) });
        }
        this.setState({ filters: { ...this.state.filters, sourceTypeCollection: sourceTypes } });
    }

    getSourceTypeName = id => {
        switch (id) {
            case 1: return 'Web';
            case 2: return 'Web iOS';
            case 3: return 'Web Android';
            case 4: return 'App iOS';
            case 5: return 'App Android';
            default: return null;
        }
    }

    renderAvailableFilters = () => {

        const { filters } = this.props;
        let availableFilters = [];

        if (filters.customerStatus === null) {
            availableFilters.push({ filter: 'customer_status', name: i18n.t('screens:marketingAutomationScreen.customerStatusFilter') })
        }

        if (filters.vip === null) {
            availableFilters.push({ filter: 'vip_status', name: i18n.t('screens:marketingAutomationScreen.vipStatusFilter') })
        }

        if (filters.minOrderCount === null && filters.maxOrderCount === null) {
            availableFilters.push({ filter: 'order_count', name: i18n.t('screens:marketingAutomationScreen.orderCountFilter') })
        }

        if (filters.minAverageOrderValue === null && filters.maxAverageOrderValue === null) {
            availableFilters.push({ filter: 'average_order_value', name: i18n.t('screens:marketingAutomationScreen.averageOrderValueFilter') })
        }

        if (filters.minLifetimeOrderValue === null && filters.maxLifetimeOrderValue === null) {
            availableFilters.push({ filter: 'lifetime_order_value', name: i18n.t('screens:marketingAutomationScreen.lifetimeOrderValueFilter') })
        }

        if (filters.minOrderFrequency === null && filters.maxOrderFrequency === null) {
            availableFilters.push({ filter: 'order_frequency', name: i18n.t('screens:marketingAutomationScreen.orderFrequencyFilter') })
        }

        if (filters.firstOrderStartDate === null && filters.firstOrderEndDate === null) {
            availableFilters.push({ filter: 'first_order', name: i18n.t('screens:marketingAutomationScreen.firstOrderFilter') })
        }

        if (filters.lastOrderStartDate === null && filters.lastOrderEndDate === null) {
            availableFilters.push({ filter: 'last_order', name: i18n.t('screens:marketingAutomationScreen.lastOrderFilter') })
        }

        if (filters.minHourOfDay === null && filters.maxHourOfDay === null) {
            availableFilters.push({ filter: 'hour_of_day', name: i18n.t('screens:marketingAutomationScreen.hourOfDayFilter') })
        }

        if (filters.minDayOfWeek === null && filters.maxDayOfWeek === null) {
            availableFilters.push({ filter: 'day_of_week', name: i18n.t('screens:marketingAutomationScreen.dayOfWeekFilter') })
        }

        if (filters.productPosId === null) {
            availableFilters.push({ filter: 'product_pos_id', name: i18n.t('screens:marketingAutomationScreen.productFilter') })
        }

        if (filters.promotionId === null) {
            availableFilters.push({ filter: 'promotion_id', name: i18n.t('screens:marketingAutomationScreen.promotionFilter') })
        }

        if (filters.lastContactStartRange === null && filters.lastContactEndRange === null) {
            availableFilters.push({ filter: 'last_contact', name: i18n.t('screens:marketingAutomationScreen.lastContactFilter') })
        }

        if (filters.redeemed === null) {
            availableFilters.push({ filter: 'redeemed', name: i18n.t('screens:marketingAutomationScreen.redeemedFilter') })
        }

        if (filters.orderTypeCollection.length === 0) {
            availableFilters.push({ filter: 'order_types', name: i18n.t('screens:marketingAutomationScreen.orderTypesFilter') })
        }

        if (filters.paymentTypeCollection.length === 0) {
            availableFilters.push({ filter: 'tender_types', name: i18n.t('screens:marketingAutomationScreen.tenderTypesFilter') })
        }

        if (filters.sourceTypeCollection.length === 0) {
            availableFilters.push({ filter: 'source_types', name: i18n.t('screens:marketingAutomationScreen.sourceTypesFilter') })
        }

        return availableFilters.map(filter => {
            return (
                <React.Fragment key={filter.filter}>
                    {this.renderSingleFilter(filter)}
                </React.Fragment>
            );
        })

    }

    renderSingleFilter = (filter) => {

        const { singleItemFilter, line, openedFilter } = styles;
        const style = filter.filter === this.state.selectedFilter ? { ...singleItemFilter, ...openedFilter } : singleItemFilter;
        const materialIconname = filter.filter === this.state.selectedFilter ? 'keyboard_arrow_left' : 'keyboard_arrow_right';
        const materialIconColor = filter.filter === this.state.selectedFilter ? '#0f84cc' : 'black';

        return (
            <React.Fragment>
                <div key={filter.filter} style={style} onClick={() => this.selectFilter(filter.filter)} >
                    <div>
                        {filter.name}
                    </div>
                    <MaterialIcon icon={materialIconname} size={25} color={materialIconColor} />
                </div>
                <hr style={line} />
            </React.Fragment>

        );
    }

    renderCustomerStatusOptions = () => {

        const { flexSpaceBetween, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.customerStatus')}
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                        <Input style={selectWithFixedWidth} type="select" id="customerStatus" name="customerStatus" value={this.state.filters.customerStatus === null ? '' : this.state.filters.customerStatus} onChange={this.changeState}>
                            <option value={''}> </option>
                            <option value={'REGULAR'}>{i18n.t('screens:customerInsightScreen.regular')}</option>
                            <option value={'INFREQUENT'}>{i18n.t('screens:customerInsightScreen.infrequent')}</option>
                            <option value={'AT_RISK'}>{i18n.t('screens:customerInsightScreen.atRisk')}</option>
                            <option value={'LOST'}>{i18n.t('screens:customerInsightScreen.lost')}</option>
                        </Input>
                    </div>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.customerStatusFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderCustomerVipStatusOptions = () => {

        const { flexSpaceBetween, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.vipStatus')}
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                        <Input style={selectWithFixedWidth} type="select" id="vip" name="vip" value={this.state.filters.vip === null ? '' : this.state.filters.vip} onChange={this.changeState}>
                            <option value={''}> </option>
                            <option value={true}>{i18n.t('screens:marketingAutomationScreen.vipCustomers')}</option>
                            <option value={false}>{i18n.t('screens:marketingAutomationScreen.noVipCustomers')}</option>
                        </Input>
                    </div>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.vipStatusFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderRedeemedCodesOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label for="redeemed" style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.customerWith')}</Label>
                    <Input style={{ ...selectWithFixedWidth, width: '130px', margin: '0 5px 0 5px' }} type="select" name="redeemed" id="redeemed" value={this.state.filters.redeemed === null ? '' : this.state.filters.redeemed} onChange={this.changeState}>
                        <option value={''}> </option>
                        <option value={true}>{i18n.t('screens:marketingAutomationScreen.redeemed')}</option>
                        <option value={false}>{i18n.t('screens:marketingAutomationScreen.unredeemed')}</option>
                    </Input>
                    <Label for="redeemed" style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.promoCodes')}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.redeemedFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderOrderCountOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="minOrderCount" id="minOrderCount" value={this.state.filters.minOrderCount === null ? '' : this.state.filters.minOrderCount}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="maxOrderCount" id="maxOrderCount" value={this.state.filters.maxOrderCount === null ? '' : this.state.filters.maxOrderCount}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.orders')}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.orderCountFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderAverageOrderValueOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="minAverageOrderValue" id="minAverageOrderValue" value={this.state.filters.minAverageOrderValue === null ? '' : this.state.filters.minAverageOrderValue}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="maxAverageOrderValue" id="maxAverageOrderValue" value={this.state.filters.maxAverageOrderValue === null ? '' : this.state.filters.maxAverageOrderValue}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{this.props.currency}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.averageOrderValueFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderLifetimeOrderValueOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="minLifetimeOrderValue" id="minLifetimeOrderValue" value={this.state.filters.minLifetimeOrderValue === null ? '' : this.state.filters.minLifetimeOrderValue}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="maxLifetimeOrderValue" id="maxLifetimeOrderValue" value={this.state.filters.maxLifetimeOrderValue === null ? '' : this.state.filters.maxLifetimeOrderValue}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{this.props.currency}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.lifetimeOrderValueFilterDescription')}</div>
            </React.Fragment>
        );
    }

    renderOrderFrequencyOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number" name="minOrderFrequency"
                        id="minOrderFrequency" value={this.state.filters.minOrderFrequency === null ? '' : this.state.filters.minOrderFrequency}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number" name="maxOrderFrequency"
                        id="maxOrderFrequency" value={this.state.filters.maxOrderFrequency === null ? '' : this.state.filters.maxOrderFrequency}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.days').toLowerCase()}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.orderFrequencyFilterDescription')}</div>
                <div>{i18n.t('screens:marketingAutomationScreen.forExample')}:</div>
                <div>{i18n.t('screens:marketingAutomationScreen.orderFrequencyFilterDescriptionSub')}</div>
                <div>{i18n.t('screens:marketingAutomationScreen.orderFrequencyFilterDescriptionSubTwo')}</div>
                <div>{i18n.t('screens:marketingAutomationScreen.orderFrequencyFilterDescriptionSubThree')}</div>
            </React.Fragment>
        );
    }

    renderDateOptions = (type) => {
        // type 1 = First order
        // type 2 = Last order

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        const fromNameField = type === 1 ? "firstOrderStartDate" : "lastOrderStartDate" ;
        const toNameField = type === 1 ? "firstOrderEndDate" : "lastOrderEndDate";
        const renderOrderDateDescription = type === 1 ? i18n.t('screens:marketingAutomationScreen.firstOrderFilterDescription') : i18n.t('screens:marketingAutomationScreen.lastOrderFilterDescription');
        
        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, width: '150px', margin: '0 5px 0 5px' }} type="date" name={fromNameField}
                        id={fromNameField} min={0} onChange={this.changeDateState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, width: '150px', margin: '0 5px 0 5px' }} type="date" name={toNameField}
                        id={toNameField} min={0} onChange={this.changeDateState} />
                </div>
                <hr style={lineWithSpace} />
                <div>{renderOrderDateDescription}</div>
            </React.Fragment>
        );
    }

    renderLastContactOptions = () => {
        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="lastContactStartRange" id="lastContactStartRange" value={this.state.filters.lastContactStartRange === null ? '' : this.state.filters.lastContactStartRange}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="number"
                        name="lastContactEndRange" id="lastContactEndRange" value={this.state.filters.lastContactEndRange === null ? '' : this.state.filters.lastContactEndRange}
                        min={0} onChange={this.changeState} />
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.days').toLowerCase()}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.lastContactFilterDescription')}</div>
                <div>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.lastContactFilterDescriptionSub')}`}</div>
                <div>{i18n.t('screens:marketingAutomationScreen.lastContactFilterDescriptionSubTwo')}</div>
            </React.Fragment>
        );
    }

    renderProductIdOptions = () => {
        const { flexSpaceBetween, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.productName')}
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                        <Input style={{ ...selectWithFixedWidth, width: '200px' }} type="text" name="productPosId" id="productPosId"
                            autoComplete="off"
                            min={0}
                            value={this.state.productName}
                            onChange={this.changeProductName}
                            onKeyUp={(e) => this.handleProductKeyUp(e)}
                            onBlur={() => this.handleProductAutoSearchFocusOut()}
                        />
                    </div>
                </div>
                <hr style={lineWithSpace} />
                {this.state.matchedProductsFromSearch.length ? this.renderProductSearchResults() : ''}
                <div>{i18n.t('screens:marketingAutomationScreen.productFilterDescription')}</div>
                <div style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.productFilterDescriptionSub')}</div>
            </React.Fragment>
        );
    }

    //Auto search components and functions for PRODUCT SEARCH from here
    handleProductKeyUp = (e) => {
        this.handleProductAutoSearch();
        //If backspace or delete pressed trigger the autosearch
        let keyCode = e.keyCode;
        let searchedProductToString = String(this.state.productName);

        if (keyCode === 8 || keyCode === 46) {
            if (searchedProductToString.length >= 3) {
                this.handleProductAutoSearch();
            } else {
                this.setState({ matchedProductsFromSearch: [] });
            }
        }
    }

    handleProductAutoSearchFocusOut = () => {
        let searchedProduct = String(this.state.productName);

        if (searchedProduct.length < 3) {
            let emptyMatchedProductsFromSearchArray = this.state.matchedProductsFromSearch.filter((product) => null);
            this.setState({ matchedProductsFromSearch: emptyMatchedProductsFromSearchArray });
        } else {
            // If search string is longer than 2 characters activate the search
            this.handleProductAutoSearch();
        }
    }

    handleProductAutoSearch() {
        if (!this.state.products.length) {
            return;
        }

        let searchedProduct = this.state.productName.toLowerCase();
        let searchStringLength = String(this.state.productName).length;
        // Trigger autosearch
        if (searchStringLength >= 3) {
            // filter the products for everyone that has a match with the user input
            let matchedProducts = this.state.products.filter((product) => product.name.toLowerCase().includes(searchedProduct));
            this.setState({ matchedProductsFromSearch: matchedProducts });
        } else {
            let emptyMatchedProductsFromSearchArray = this.state.matchedProductsFromSearch.filter((product) => null);
            this.setState({ matchedProductsFromSearch: emptyMatchedProductsFromSearchArray });
        }
    }

    renderProductSearchResults = () => {
        const { searchResultContainer } = styles;

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={searchResultContainer}>
                    <ul className='auto-search-triggers'>
                        {
                            this.state.matchedProductsFromSearch.map((result) => {
                                return <li key={result.id} onClick={() => this.getProductName(result.name, result.posId)}>{result.name}</li>
                            })
                        }
                    </ul>
                </div>
            </div>

        );
    }

    getProductName(selectedProductName, selectedProductId) {
        let products = this.state.products;
        let emptyMatchedProductsFromSearchArray = this.state.matchedProductsFromSearch.filter((product) => null);
        this.setState({ filters: { ...this.state.filters, productPosId: selectedProductId }, productName: selectedProductName, matchedProductsFromSearch: emptyMatchedProductsFromSearchArray });
        if(products && products.length) {
            products.map((product, i) => {
                if(product.name === selectedProductName) {
                    this.setState({
                        isFromMatchedProductsSearch: true
                    })
                }
            })
        }
    }
    //Auto search components and fuctions FOR PRODUCT SEARCH to here

    renderPromotionIdOptions = () => {

        const { flexSpaceBetween, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.promotionName')}
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                        <Input style={{ ...selectWithFixedWidth, width: '200px' }} type="text" name="promotionId" id="promotionId"
                            autoComplete="off"
                            min={0}
                            value={this.state.promotionName}
                            onChange={this.changePromotionName}
                            onKeyUp={(e) => this.handlePromotionKeyUp(e)}
                            onBlur={() => this.handlePromotionAutoSearchFocusOut()}
                        />
                    </div>
                </div>
                <hr style={lineWithSpace} />
                {this.state.matchedPromotionsFromSearch.length ? this.renderPromotionSearchResults() : ''}
                <div>{i18n.t('screens:marketingAutomationScreen.promotionFilterDescription')}</div>
            </React.Fragment>
        );
    }

    //Auto search components and fuctions FOR PROMOTION SEARCH from here
    handlePromotionKeyUp = (e) => {
        this.handlePromotionAutoSearch();
        //If backspace or delete pressed trigger the autosearch
        let keyCode = e.keyCode;
        let searchedPromotionToString = String(this.state.promotionName);

        if (keyCode === 8 || keyCode === 46) {
            if (searchedPromotionToString.length >= 3) {
                this.handlePromotiontAutoSearch();
            } else {
                this.setState({ matchedPromotionsFromSearch: [] });
            }
        }
    }

    handlePromotionAutoSearchFocusOut = () => {
        let searchedPromotion = String(this.state.promotionName);

        if (searchedPromotion.length < 3) {
            let emptyMatchedPromotionsFromSearchArray = this.state.matchedPromotionsFromSearch.filter(() => null);
            this.setState({ matchedPromotionsFromSearch: emptyMatchedPromotionsFromSearchArray });
        } else {
            // If search string is longer than 2 characters activate the search
            this.handlePromotionAutoSearch();
        }
    }

    handlePromotionAutoSearch() {
        if (!this.state.promotions.length) {
            return;
        }

        let searchedPromotion = this.state.promotionName.toLowerCase();
        let searchStringLength = String(this.state.promotionName).length;
        // Trigger autosearch
        if (searchStringLength >= 3) {
            // filter the products for everyone that has a match with the user input
            let matchedPromotions = this.state.promotions.filter((promo) => promo.name.toLowerCase().includes(searchedPromotion));
            this.setState({ matchedPromotionsFromSearch: matchedPromotions });
        } else {
            let emptyMatchedPromotionsFromSearchArray = this.state.matchedPromotionsFromSearch.filter(() => null);
            this.setState({ matchedPromotionsFromSearch: emptyMatchedPromotionsFromSearchArray });
        }
    }

    renderPromotionSearchResults = () => {
        const { searchResultContainer } = styles;

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={searchResultContainer}>
                    <ul className='auto-search-triggers'>
                        {
                            this.state.matchedPromotionsFromSearch.map((result) => {
                                return <li key={result.id} onClick={() => this.getPromotionName(result.name, result.id)}>{result.name}</li>
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }

    getPromotionName(selectedPromotionName, selectedPromotionId) {
        const promotions = this.state.promotions;
        let emptyMatchedPromotionsFromSearchArray = this.state.matchedPromotionsFromSearch.filter(() => null);
        this.setState({ filters: { ...this.state.filters, promotionId: selectedPromotionId }, promotionName: selectedPromotionName, matchedPromotionsFromSearch: emptyMatchedPromotionsFromSearchArray });

        if(promotions && promotions.length) {
            promotions.map((promotion, i) => {
                if(promotion.name === selectedPromotionName) {
                    this.setState({
                        isFromMatchedPromotionsSearch: true
                    })
                }
            })
        }
    }
    //Auto search components and fuctions FOR PROMOTION SEARCH to here

    renderHourOfDayOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="select"
                        name="minHourOfDay" id="minHourOfDay" value={this.state.filters.minHourOfDay === null ? '' : this.state.filters.minHourOfDay}
                        onChange={this.changeState}>
                        {this.renderHourOfDaySelectOptions()}
                    </Input>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, margin: '0 5px 0 5px' }} type="select"
                        name="maxHourOfDay" id="maxHourOfDay" value={this.state.filters.maxHourOfDay === null ? '' : this.state.filters.maxHourOfDay}
                        onChange={this.changeState}>
                        {this.renderHourOfDaySelectOptions()}
                    </Input>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.oClock')}</Label>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.hourOfDayFilterDescription')}</div>
                <div>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.hourOfDayFilterDescriptionSub')}`}</div>
                <div>{i18n.t('screens:marketingAutomationScreen.hourOfDayFilterDescriptionSubTwo')}</div>
                <div style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.hourOfDayFilterDescriptionSubThree')}</div>
            </React.Fragment>
        );
    }

    renderDayOfWeekOptions = () => {

        const { verticleCenter, selectWithFixedWidth, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={{ ...verticleCenter, paddingTop: '5px' }}>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.between')}</Label>
                    <Input style={{ ...selectWithFixedWidth, width: '130px', margin: '0 5px 0 5px' }} type="select"
                        name="minDayOfWeek" id="minDayOfWeek" value={this.state.filters.minDayOfWeek === null ? '' : this.state.filters.minDayOfWeek}
                        onChange={this.changeState}>
                        {this.renderDayOfWeekSelectOptions()}
                    </Input>
                    <Label style={{ fontWeight: 'bold', margin: 0 }}>{i18n.t('screens:marketingAutomationScreen.and')}</Label>
                    <Input style={{ ...selectWithFixedWidth, width: '130px', margin: '0 5px 0 5px' }} type="select"
                        name="maxDayOfWeek" id="maxDayOfWeek" value={this.state.filters.maxDayOfWeek === null ? '' : this.state.filters.maxDayOfWeek}
                        onChange={this.changeState}>
                        {this.renderDayOfWeekSelectOptions()}
                    </Input>
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.dayOfWeekFilterDescription')}</div>
                <div>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.dayOfWeekFilterDescriptionSub')}`}</div>
                <div style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.dayOfWeekFilterDescriptionSubTwo')}</div>
            </React.Fragment>
        );
    }

    renderOrderTypesOptions = () => {

        const { flexSpaceBetween, checkbox, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.delivery')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="1" checked={this.getOrderTypeValue(1)} onChange={this.changeOrderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.pickUp')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="2" checked={this.getOrderTypeValue(2)} onChange={this.changeOrderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.curbside')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="4" checked={this.getOrderTypeValue(4)} onChange={this.changeOrderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.inStore')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="5" checked={this.getOrderTypeValue(5)} onChange={this.changeOrderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.orderTypesFilterDescription')}</div>
                <div>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.orderTypesFilterDescriptionSub')}`}</div>
            </React.Fragment>
        );
    }

    renderTenderTypesOptions = () => {

        const { flexSpaceBetween, checkbox, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.creditCard')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="1" checked={this.getTenderTypeValue(1)} onChange={this.changeTenderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.cash')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="2" checked={this.getTenderTypeValue(2)} onChange={this.changeTenderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.loyalty')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="3" checked={this.getTenderTypeValue(3)} onChange={this.changeTenderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {i18n.t('screens:marketingAutomationScreen.giftCard')}
                    </div>
                    <Input style={checkbox} type="checkbox" name="4" checked={this.getTenderTypeValue(4)} onChange={this.changeTenderTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.tenderTypesFilterDescription')}</div>
                <div style={{marginBottom: '30px'}}>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.tenderTypesFilterDescriptionSub')}`}</div>
            </React.Fragment>
        );
    }

    renderSourceTypesOptions = () => {

        const { flexSpaceBetween, checkbox, lineWithSpace } = styles;

        return (
            <React.Fragment>
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {"Web"}
                    </div>
                    <Input style={checkbox} type="checkbox" name="1" checked={this.getSourceTypeValue(1)} onChange={this.changeSourceTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {"Web iOS"}
                    </div>
                    <Input style={checkbox} type="checkbox" name="2" checked={this.getSourceTypeValue(2)} onChange={this.changeSourceTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {"Web Android"}
                    </div>
                    <Input style={checkbox} type="checkbox" name="3" checked={this.getSourceTypeValue(3)} onChange={this.changeSourceTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {"App IOS"}
                    </div>
                    <Input style={checkbox} type="checkbox" name="4" checked={this.getSourceTypeValue(4)} onChange={this.changeSourceTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div style={flexSpaceBetween}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontWeight: 'bold' }}>
                        {"App Android"}
                    </div>
                    <Input style={checkbox} type="checkbox" name="5" checked={this.getSourceTypeValue(5)} onChange={this.changeSourceTypeValue} />
                </div>
                <hr style={lineWithSpace} />
                <div>{i18n.t('screens:marketingAutomationScreen.sourceTypesFilterDescription')}</div>
                <div style={{marginBottom: '30px'}}>{`${i18n.t('screens:marketingAutomationScreen.forExample')}: ${i18n.t('screens:marketingAutomationScreen.sourceTypesFilterDescriptionSub')}`}</div>
            </React.Fragment>
        );
    }

    renderHourOfDaySelectOptions = () => {
        return (
            <React.Fragment>
                <option value={''}> </option>
                <option value={0}>{'00:00'}</option>
                <option value={1}>{'01:00'}</option>
                <option value={2}>{'02:00'}</option>
                <option value={3}>{'03:00'}</option>
                <option value={4}>{'04:00'}</option>
                <option value={5}>{'05:00'}</option>
                <option value={6}>{'06:00'}</option>
                <option value={7}>{'07:00'}</option>
                <option value={8}>{'08:00'}</option>
                <option value={9}>{'09:00'}</option>
                <option value={10}>{'10:00'}</option>
                <option value={11}>{'11:00'}</option>
                <option value={12}>{'12:00'}</option>
                <option value={13}>{'13:00'}</option>
                <option value={14}>{'14:00'}</option>
                <option value={15}>{'15:00'}</option>
                <option value={16}>{'16:00'}</option>
                <option value={17}>{'17:00'}</option>
                <option value={18}>{'18:00'}</option>
                <option value={19}>{'19:00'}</option>
                <option value={20}>{'20:00'}</option>
                <option value={21}>{'21:00'}</option>
                <option value={22}>{'22:00'}</option>
                <option value={23}>{'23:00'}</option>
            </React.Fragment>
        );
    }

    renderDayOfWeekSelectOptions = () => {
        return (
            <React.Fragment>
                <option value={''}> </option>
                <option value={1}>{i18n.t('screens:marketingAutomationScreen.monday')}</option>
                <option value={2}>{i18n.t('screens:marketingAutomationScreen.tuesday')}</option>
                <option value={3}>{i18n.t('screens:marketingAutomationScreen.wednesday')}</option>
                <option value={4}>{i18n.t('screens:marketingAutomationScreen.thursday')}</option>
                <option value={5}>{i18n.t('screens:marketingAutomationScreen.friday')}</option>
                <option value={6}>{i18n.t('screens:marketingAutomationScreen.saturday')}</option>
                <option value={7}>{i18n.t('screens:marketingAutomationScreen.sunday')}</option>
            </React.Fragment>
        );
    }

    renderFilterOptions = () => {
        if (this.state.selectedFilter !== null) {
            switch (this.state.selectedFilter) {
                case 'customer_status': return this.renderCustomerStatusOptions();
                case 'vip_status': return this.renderCustomerVipStatusOptions();
                case 'order_count': return this.renderOrderCountOptions();
                case 'average_order_value': return this.renderAverageOrderValueOptions();
                case 'lifetime_order_value': return this.renderLifetimeOrderValueOptions();
                case 'order_frequency': return this.renderOrderFrequencyOptions();
                case 'first_order': return this.renderDateOptions(1);
                case 'last_order': return this.renderDateOptions(2);
                case 'hour_of_day': return this.renderHourOfDayOptions();
                case 'day_of_week': return this.renderDayOfWeekOptions();
                case 'product_pos_id': return this.renderProductIdOptions();
                case 'promotion_id': return this.renderPromotionIdOptions();
                case 'last_contact': return this.renderLastContactOptions();
                case 'redeemed': return this.renderRedeemedCodesOptions();
                case 'order_types': return this.renderOrderTypesOptions();
                case 'tender_types': return this.renderTenderTypesOptions();
                case 'source_types': return this.renderSourceTypesOptions();
                default: return null;
            }
        }
        return null;
    }

    renderActionButtons = () => {

        const { actionButton } = styles;

        if (this.state.selectedFilter === null) {
            return null;
        }

        let isAddButtonDisabled = false;
        const isProductsFilter = this.state.selectedFilter === 'product_pos_id';
        const isPromotionFilter = this.state.selectedFilter === 'promotion_id';
        
        if(isProductsFilter && !this.state.isFromMatchedProductsSearch) {
            isAddButtonDisabled = true;
        } else if(isPromotionFilter && !this.state.isFromMatchedPromotionsSearch) {
            isAddButtonDisabled = true;
        } else {
            isAddButtonDisabled = false
        }
        
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '15px' }} >
                <button disabled={isAddButtonDisabled} style={{ ...actionButton, backgroundColor: '#1386c1', border: 'none' }} onClick={() => this.props.applyFilters(this.state.filters)}>
                    {i18n.t('common:buttons.add')}
                </button>
                <div style={{ ...actionButton, backgroundColor: '#9c9c9c' }} onClick={() => this.props.toggleModal()}>
                    {i18n.t('common:buttons.cancel')}
                </div>
            </div >
        );
    }

    renderSpecificFilters = () => {

        const { filterOptionsContainer } = styles;

        return (
            <div style={filterOptionsContainer}>
                <div style={{ height: '90%', padding: '40px 60px 10px 60px', overflowY: 'scroll' }}>
                    {this.renderFilterOptions()}
                </div>
                {this.renderActionButtons()}
            </div>
        );
    }

    render() {
        const { mainContainer, rowStyle, colStyle } = styles;

        return (
            <Container fluid style={mainContainer}>
                <Row style={rowStyle}>
                    <Col sm={6} style={colStyle}>
                        {this.renderAvailableFilters()}
                    </Col>
                    <Col sm={6} style={colStyle}>
                        {this.renderSpecificFilters()}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default FilterSelectionScreen;

const styles = {
    mainContainer: {
        padding: '0',
        marginTop: '-15px',
        marginBottom: '-15px'
    },
    rowStyle: {
        margin: '0',
    },
    colStyle: {
        padding: '0 20px 0 20px'
    },
    filterOptionsContainer: {
        backgroundColor: '#f2f2f2',
        height: '100%',
        minHeight: '480px'
    },
    singleItemFilter: {
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
    },
    openedFilter: {
        color: '#0f84cc'
    },
    line: {
        margin: '0 0 3px 0'
    },
    lineWithSpace: {
        margin: '5px 0 5px 0'
    },
    flexSpaceBetween: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    selectWithFixedWidth: {
        height: '30px',
        fontWeight: 'bold',
        width: '100px',
        borderRadius: '5px',
    },
    checkbox: {
        width: '20px',
        height: '20px',
        position: 'static'
    },
    actionButton: {
        borderRadius: '15px',
        padding: '0 15px 0 15px',
        margin: '0 10px 0 0',
        color: 'white',
        cursor: 'pointer'
    },
    verticleCenter: {
        display: 'flex',
        alignItems: 'center'
    },
    searchResultContainer: {
        backgroundColor: '#ffffff',
        display: 'inline-block',
        width: 200,
        border: '1px solid #d2d2d2'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/FilterSelectionScreen.js